export default {
  baseStyle: {
    textAlign: "left",
    fontSize: "6xl",
    color: "deepGreen.500",
  },
  variants: {
    "in-card": {
      color: "paleGrey.500",
      textAlign: "center",
    },
    "in-box": {
      color: "dullBrown.500",
      fontSize: "md",
      fontWeight: "semibold",
    },
    "in-markdown": {
      color: "darkIndigo.500",
      //fontSize: "md",
      fontWeight: "semibold",
    },
  },
}
